import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export enum CouponTypeEnum {
  Percentage = 'PERCENTAGE',
  Fixed = 'FIXED',
  MktUniteFee = 'MktUniteFee',
  WarehouseFees = 'WarehouseFees',
}
export interface Coupon {
  country: (PkgWarehouse | 'all')[]
  minPayment: number
  packagesUsed: string[]
  totalFinalPayments: number
  limitedUses: string
  expiredAt: string
  timesUsed: number
  createdAt: string
  familyName: string
  usersAllowed: string[]
  value: string
  code: string
  shippingMethod: string
  revenue: string
  usersUsed: string[]
  updatedAt: string
  notes: string
  productCategory: string
  id: string
  refUserId: string
  limitedUsesForUser: string
  type: CouponTypeEnum
}
